import { lazy } from "react";

const ComingSoon = lazy(() => import("@/pages/Others/ComingSoon/ComingSoon"));
const Maintenance = lazy(() => import("@/pages/Others/Maintenance/Maintenance"));
const NotFound = lazy(() => import("@/pages/Others/NotFound/NotFound"));

export var othersPublicRoutes = [
    { path: "/notfound", component: <NotFound /> },
    { path: "/pages-maintenance", component: <Maintenance /> },
    { path: "/pages-coming-soon", component: <ComingSoon /> },

];